// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"39626853","428":"56193206","678":"56193206","858":"ba8d6d38","978":"56193206"}[chunkId] + ".chunk.css";
};